import { forwardRef, type Ref, type SVGProps } from "react";

function SvgNonInstantPay(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#non_instant_pay_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#non_instant_pay_svg__b)" strokeWidth={20} />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m96 47 3.592 3.47a1.03 1.03 0 0 1 0 1.492L96 55.432M80 73l-3.592-3.47a1.03 1.03 0 0 1 0-1.492L80 64.569m-3.592 4.216H97.09c1.607 0 2.909-1.259 2.909-2.811v-4.216M76 57.54v-3.514c0-1.552 1.302-2.81 2.91-2.81H99.5"
        />
      </g>
      <rect width={39} height={39} x={29.5} y={10.5} fill="#BD6801" rx={19.5} />
      <rect width={39} height={39} x={29.5} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.51}
        d="M49 24v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="non_instant_pay_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="non_instant_pay_svg__a">
          <rect width={100} height={100} x={37.5} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgNonInstantPay);
export default ForwardRef;
